import { FC, ReactNode } from 'react'
import { SpecialOfferSkeleton } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/SpecialOffer'
import { GoThisWeekSkeleton } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/GoThisWeek'
import { NewDishesSkeleton } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/NewDishes'
import { SelectionSkeleton } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/Selection'
import { LookAlsoSkeleton } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/LookAlso'
import { ListSkeleton } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/List'
import { BookingSkeleton } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/Booking'
import { GigAssistSkeleton } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/GigAssist'

import { BlockBoundary } from '@shared/lib/components/BlockBoundary'

interface Props {
  type?:
    | 'list'
    | 'special-offer'
    | 'new-dishes'
    | 'look-also'
    | 'selection'
    | 'map'
    | 'go-this-week'
    | 'booking'
    | 'gig-assist'
  children?: ReactNode
  sizes?: string
  className?: string
  animate?: boolean
}

const componentsByType = {
  list: ListSkeleton,
  'special-offer': SpecialOfferSkeleton,
  'new-dishes': NewDishesSkeleton,
  'look-also': LookAlsoSkeleton,
  selection: SelectionSkeleton,
  map: ListSkeleton,
  'go-this-week': GoThisWeekSkeleton,
  booking: BookingSkeleton,
  'gig-assist': GigAssistSkeleton,
}

const Skeleton: FC<Props> = ({ type = 'list', children, sizes = 'L', className = '', animate = true, ...props }) => {
  const Template = componentsByType[type as keyof typeof componentsByType]

  return (
    <BlockBoundary>
      <Template sizes={sizes} className={className} animate={animate} {...props}>
        {children}
      </Template>
    </BlockBoundary>
  )
}

export default Skeleton
